// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import {
    getAllAvailableColumns,
    getAvailableColumns
} from '../../../shared/services/available-excel-columns';
import ExcelLayoutModal from '../../../shared/components/excel-layout/excel-layout-modal';
import ExportToExcel from '../../../shared/state/export-to-excel';
import {FormattedMessage} from 'react-intl';
import PartReturn from '@deere/cps-it.warranty-model-factory/lib/part-return';
import PartReturnList from '../../shared/components/part-return-list';
import RefinableListWidgetWithExportAndLayouts from '../../../shared/components/refinable-list-widget/refinable-list-widget-with-export-and-layouts';
import SearchFilters from '../state/search-filters';
import State from '../state';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import filterOptions from '../../shared/state/part-return-filter-options';
import {getPartRequestsColumns} from '../../../part-requests/shared/services/part-requests-excel-columns';
import {getSortByList} from '../../../shared/services/get-excel-layout-modal-sort-by-list';
import partReturnSortOptions from '../../shared/state/part-return-sort-options';

function handleCreateExcelLayout() {

    const availableColumns = getAllAvailableColumns('partRequests');

    this.actions.updateExcelLayoutModalExcelLayout(true);
    this.actions.updateExcelLayoutModalIsNewLayout(true, 'partRequests');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

    if (!this.exportToExcel.excelLayouts.partRequests.length) {

        this.actions.updateExcelLayoutModalExcelLayoutIsDefault(true);

    }

    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleEditExcelLayout() {

    const availableColumns = getAvailableColumns('partRequests', this.exportToExcel.selectedExcelLayout.partRequests.columns);

    this.actions.updateExcelLayoutModalExcelLayout(false, this.exportToExcel.selectedExcelLayout.partRequests);
    this.actions.updateExcelLayoutModalIsNewLayout(false, 'partRequests');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);
    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleExcelLayoutChange(selectedLayout) {

    const availableColumns = getAvailableColumns('partRequests', selectedLayout.columns);

    this.actions.updateSelectedExcelLayout(selectedLayout, 'partRequests');
    this.actions.updateExcelLayoutModalExcelLayout(false, selectedLayout);
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

}

function handleDownloadToExcel() {

    this.props.actions.exportToExcel(
        this.props.facets.props.facets,
        this.context.user.getLocale(),
        this.props.exportToExcel.selectedExcelLayout.partRequests.name,
        this.props.exportToExcel.selectedExcelLayout.partRequests.listId
    );

}

function handleColumnMove(dragIndex, hoverIndex, listId, dragCard) {

    listId === 'available-items' ?
        this.actions.updateExcelLayoutModalAvailableColumnsOrder(dragIndex, hoverIndex, dragCard) :
        this.actions.updateExcelLayoutModalExcelLayoutColumnsOrder(dragIndex, hoverIndex, dragCard);

}

function handleColumnPush(column, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.pushExcelLayoutModalExcelLayoutColumn(column) :
        this.actions.pushExcelLayoutModalAvailableColumn(column);

}

function handleColumnRemove(index, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.removeExcelLayoutModalAvailableColumn(index) :
        this.actions.removeExcelLayoutModalExcelLayoutColumn(index);

}

function handleExcelLayoutDelete() {

    this.actions.deleteExcelLayout(this.exportToExcel.selectedExcelLayout.partRequests.name, this.exportToExcel.selectedExcelLayout.partRequests.listId, 'partRequests');

}

function handleLayoutNameBlur(layoutName) {

    const nameAlreadyExists = this.exportToExcel.excelLayouts.partRequests.some(layout => layout.name === layoutName);

    nameAlreadyExists ?
        this.actions.updateExcelLayoutModalIsNameValid(false) :
        this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleLayoutNameChange(layoutName) {

    this.actions.updateExcelLayoutModalLayoutName(layoutName);

}

function handleExcelLayoutModalClose() {

    this.actions.updateExcelLayoutModalVisibility(false);
    this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleSaveExcelLayout() {

    this.actions.saveExcelLayout(this.exportToExcel.excelLayoutModal.excelLayout, 'partRequests');

}

function handleSetAsDefaultChange(isSelected) {

    this.actions.updateExcelLayoutModalExcelLayoutIsDefault(isSelected);

}

function handleSortByChange(sortByColumn) {

    this.actions.updateExcelLayoutModalExcelLayoutSortBy(sortByColumn, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateExcelLayoutModalExcelLayoutSortDirection(sortDirection, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}
const PartReturnListWrapper = (props, context) => {

    let sortedPartReturns;

    sortedPartReturns = [...props.partReturns];
    sortedPartReturns = sortCollection(props.searchFilters.sortBy, props.searchFilters.sortDirection, sortedPartReturns);
    sortedPartReturns = filterCollection(props.searchFilters.filterBy, filterOptions, sortedPartReturns);

    return (
        <div>
            <section className='part-return-list-wrapper'>
                <RefinableListWidgetWithExportAndLayouts
                    excelLayouts={props.exportToExcel.excelLayouts.partRequests}
                    hasResults={props.openPartRequestsCount > 0}
                    onCreateLayout={props::handleCreateExcelLayout}
                    onEditLayout={props::handleEditExcelLayout}
                    onExport={{context, props}::handleDownloadToExcel}
                    onFilterByChange={props.actions.updateListFilterBy}
                    onLayoutChange={props::handleExcelLayoutChange}
                    onSortByChange={props.actions.updateListSortBy}
                    onSortDirectionChange={props.actions.updateListSortDirection}
                    searchFilters={props.searchFilters}
                    selectedLayout={props.exportToExcel.selectedExcelLayout.partRequests}
                    sortOptions={partReturnSortOptions}
                    type={State}
                />
                {props.partReturns.length || props.busyCounter ?
                    <PartReturnList partReturns={sortedPartReturns}/> :
                    <FormattedMessage id='NO_RESULTS_FOUND'/>
                }
            </section >
            <ExcelLayoutModal
                excelLayoutModal={props.exportToExcel.excelLayoutModal}
                mappingTable={getPartRequestsColumns().listColumns}
                onColumnMove={props:: handleColumnMove}
                onColumnPush={props:: handleColumnPush}
                onColumnRemove={props:: handleColumnRemove}
                onLayoutDelete={props:: handleExcelLayoutDelete}
                onLayoutNameBlur={props:: handleLayoutNameBlur}
                onLayoutNameChange={props:: handleLayoutNameChange}
                onModalClose={props:: handleExcelLayoutModalClose}
                onSaveLayout={props:: handleSaveExcelLayout}
                onSetAsDefaultChange={props:: handleSetAsDefaultChange}
                onSortByChange={props:: handleSortByChange}
                onSortDirectionChange={props:: handleSortDirectionChange}
                sortByList={getSortByList(getPartRequestsColumns().listColumns, props.exportToExcel.excelLayoutModal.excelLayout.columns)}
            />
        </div>
    );

};

PartReturnListWrapper.displayName = 'PartReturnListWrapper';
PartReturnListWrapper.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    exportToExcel: PropTypes.instanceOf(ExportToExcel).isRequired,
    openPartRequestsCount: PropTypes.number.isRequired,
    partReturns: PropTypes.arrayOf(PropTypes.instanceOf(PartReturn)).isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired
};
PartReturnListWrapper.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};
export default PartReturnListWrapper;



// WEBPACK FOOTER //
// ./src/part-requests/open-parts-requests/components/part-return-list-wrapper.js